import { render, staticRenderFns } from "./TasksPane.vue?vue&type=template&id=89fd76a4&scoped=true&"
import script from "./TasksPane.vue?vue&type=script&lang=js&"
export * from "./TasksPane.vue?vue&type=script&lang=js&"
import style0 from "./TasksPane.vue?vue&type=style&index=0&id=89fd76a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fd76a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VDivider,VRow})
